// import { all, takeLatest, put, call } from 'redux-saga/effects'
// import { push } from 'connected-react-router'

// import SignupActions from './duck'

// eslint-disable-next-line @typescript-eslint/no-empty-function
const SignupSaga = function* () {}

export default SignupSaga
